var _WebApiConsoleLogger_console;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Logger from './Logger';
export default class WebApiConsoleLogger extends Logger {
    constructor(console, config) {
        super(config);
        _WebApiConsoleLogger_console.set(this, void 0);
        __classPrivateFieldSet(this, _WebApiConsoleLogger_console, console, "f");
    }
    _debugMethod(message, ...args) {
        return __classPrivateFieldGet(this, _WebApiConsoleLogger_console, "f").debug(message, ...args);
    }
    _defaultMethod(message, ...args) {
        return __classPrivateFieldGet(this, _WebApiConsoleLogger_console, "f").log(message, ...args);
    }
    _errorMethod(message, ...args) {
        return __classPrivateFieldGet(this, _WebApiConsoleLogger_console, "f").error(message, ...args);
    }
    _infoMethod(message, ...args) {
        return __classPrivateFieldGet(this, _WebApiConsoleLogger_console, "f").info(message, ...args);
    }
    _traceMethod(message, ...args) {
        return __classPrivateFieldGet(this, _WebApiConsoleLogger_console, "f").trace(message, ...args);
    }
    _warnMethod(message, ...args) {
        return __classPrivateFieldGet(this, _WebApiConsoleLogger_console, "f").warn(message, ...args);
    }
}
_WebApiConsoleLogger_console = new WeakMap();
